// Note: only #imports is a valid source here, otherwise the app will never finish loading!!!
import { defineAppConfig } from '#imports'
import type { AppCountryConfig } from '~/index'

export default defineAppConfig({
  countryConfig: {
    at: {
      envOverwrites: {
        prod: {
          disabled: true,
        },
        staging: {
          sentryDsn: 'https://76a6e5c2d362ed2f0d3ed1234604e688@o4505946093125632.ingest.sentry.io/4505980068233216',
          internalApiUrl: 'https://shop-staging.heiland.com/at',
        },
      },
      internalApiUrl: 'https://shop.heiland.com/at',
      mainDomain: 'heiland.com',
      localName: 'Österreich',
      appBarLogo: '/logos/heiland_logo_light.svg',
      registrationPageLogo: '/logos/heiland_logo_red.svg',
      ogImage: 'https://shop.heiland.com/logos/heiland-pwa-logo.png',
      favicon: '/icons/favicon-heiland.ico',
      titleTranslationKey: 'layouts.titleHeiland',
      homeUrl: 'https://home.heiland.com',
      helpUrl: 'https://help.heiland.com/de-form/',
      searchLanguage: 'de',
      sentryDsn: 'https://76a6e5c2d362ed2f0d3ed1234604e688@o4505946093125632.ingest.sentry.io/4505980068233216',
      gtmId: 'GTM-K6T8LJSN',
      googleAdsenseId: 'ca-pub-7184100102884576',
      productFruitsCode: 'YbfZHMisYDNhU0SJ',
      intercomAppId: 'xynk1v01',
      supportEmail: 'mail@heiland.com',
      feature: {
        displayVetNarcoticsNumber: true,
        displayPharmacyReference: true,
      },
      popularProductCategories: [
        { groupHandle: 'pharma', categoryHandle: 'antiparasitika' },
        { groupHandle: 'pharma', categoryHandle: 'antiphlogistika' },
        { groupHandle: 'pharma', categoryHandle: 'impfstoffe_und_sera' },
        { groupHandle: 'pharma', categoryHandle: 'haut_haare_horngebilde' },
        { groupHandle: 'food', categoryHandle: 'futter' },
        { groupHandle: 'practice_supply', categoryHandle: 'hygiene' },
        { groupHandle: 'practice_supply', categoryHandle: 'behandlung', subCategory: 'spritzen_kanuelen_kanuelen' },
        { groupHandle: 'practice_supply', categoryHandle: 'behandlung', subCategory: 'spritzen_kanuelen_spritzen' },
      ],
      marketingCampaigns: {
      },
    },
    de: {
      envOverwrites: {
        staging: {
          gtmId: 'GTM-M2G2SF7B',
          sentryDsn: 'https://76a6e5c2d362ed2f0d3ed1234604e688@o4505946093125632.ingest.sentry.io/4505980068233216',
          internalApiUrl: 'https://shop-staging.heiland.com/de',
        },
      },
      internalApiUrl: 'https://shop.heiland.com/de',
      mainDomain: 'heiland.com',
      localName: 'Deutschland',
      appBarLogo: '/logos/heiland_logo_light.svg',
      registrationPageLogo: '/logos/heiland_logo_red.svg',
      ogImage: 'https://shop.heiland.com/logos/heiland-pwa-logo.png',
      favicon: '/icons/favicon-heiland.ico',
      titleTranslationKey: 'layouts.titleHeiland',
      homeUrl: 'https://home.heiland.com',
      helpUrl: 'https://help.heiland.com/de-form/',
      searchLanguage: 'de',
      sentryDsn: 'https://76a6e5c2d362ed2f0d3ed1234604e688@o4505946093125632.ingest.sentry.io/4505980068233216',
      gtmId: 'GTM-W86XPFMM',
      googleAdsenseId: 'ca-pub-7184100102884576',
      productFruitsCode: 'YbfZHMisYDNhU0SJ',
      intercomAppId: 'xynk1v01',
      supportEmail: 'mail@heiland.com',
      feature: {
        displayVetNarcoticsNumber: true,
        displayPharmacyReference: true,
        displayVoucherCode: true,
      },
      popularProductCategories: [
        { groupHandle: 'pharma', categoryHandle: 'antiparasitika' },
        { groupHandle: 'pharma', categoryHandle: 'antiphlogistika' },
        { groupHandle: 'pharma', categoryHandle: 'impfstoffe_und_sera' },
        { groupHandle: 'pharma', categoryHandle: 'haut_haare_horngebilde' },
        { groupHandle: 'food', categoryHandle: 'futter' },
        { groupHandle: 'practice_supply', categoryHandle: 'hygiene' },
        { groupHandle: 'practice_supply', categoryHandle: 'behandlung', subCategory: 'spritzen_kanuelen_kanuelen' },
        { groupHandle: 'practice_supply', categoryHandle: 'behandlung', subCategory: 'spritzen_kanuelen_spritzen' },
      ],
      marketingCampaigns: {
        Tessie: { startDate: '2024-10-02' },
        IMS: { startDate: '2025-05-27' },
        Inuvet2: { startDate: '2025-08-01', endDate: '2025-08-31', name: 'Inuvet - Blase' },
        Inuvet3: { startDate: '2025-10-01', endDate: '2025-10-31', name: 'Inuvet - Power' },
        Heel: { startDate: '2025-09-01', endDate: '2025-12-31' },
        Hanse: { startDate: '2025-09-01', endDate: '2026-01-01', name: 'Hanse Medical' },
        Virbac: { startDate: '2025-10-01', endDate: '2025-12-31', name: 'Virbac' },
        Virbac2: { startDate: '2025-11-01', endDate: '2025-12-31', name: 'Virbac Reconcile' },
        AnimalDeli: { startDate: '2025-11-01', endDate: '2026-01-19', name: 'Animal Deli' },
        Domespharma: { startDate: '2026-02-01', name: 'Dômes Pharma' },
      },
    },
    fr: {
      envOverwrites: {
        staging: {
          disabled: true,
          gtmId: 'GTM-NCHZZJD',
          sentryDsn: 'https://76a6e5c2d362ed2f0d3ed1234604e688@o4505946093125632.ingest.sentry.io/4505980068233216',
        },
      },
      internalApiUrl: 'https://shop.vetmazing.com/fr',
      mainDomain: 'vetmazing.com',
      localName: 'France',
      appBarLogo: '/logos/vetmazing_lightred.svg',
      registrationPageLogo: '/logos/vetmazing_logo_red.svg',
      ogImage: 'https://shop.vetmazing.com/logos/vetmazing-pwa-logo.png',
      favicon: '/icons/favicon-vetmazing.ico',
      titleTranslationKey: 'layouts.titleVetmazing',
      homeUrl: 'https://home.vetmazing.com',
      helpUrl: 'https://help.vetmazing.com/fr',
      searchLanguage: 'fr',
      sentryDsn: 'https://76a6e5c2d362ed2f0d3ed1234604e688@o4505946093125632.ingest.sentry.io/4505980068233216',
      gtmId: 'GTM-P85HCRSX',
      googleAdsenseId: 'ca-pub-7184100102884576',
      productFruitsCode: 'qgrYcgHIzObpziZG',
      intercomAppId: 'bdajhgg2',
      supportEmail: 'mail@vetmazing.com',
      feature: {
        displayOfficialClinicNumber: true,
        displayVetDiplomaNumber: true,
      },
      popularProductCategories: [
        { groupHandle: 'pharma', categoryHandle: 'antiparasitika' },
        { groupHandle: 'pharma', categoryHandle: 'antiphlogistika' },
        { groupHandle: 'pharma', categoryHandle: 'kardiovaskulaer_wirksame_pharmaka' },
        { groupHandle: 'pharma', categoryHandle: 'respirationstrakt' },
        { groupHandle: 'pharma', categoryHandle: 'hormone' },
        { groupHandle: 'pharma', categoryHandle: 'nahrungsergaenzung' },
      ],
      marketingCampaigns: {
      },
    },
  } satisfies AppCountryConfig,
})
